import { render, staticRenderFns } from "./NewMembers.vue?vue&type=template&id=927105de&"
import script from "./NewMembers.vue?vue&type=script&lang=js&"
export * from "./NewMembers.vue?vue&type=script&lang=js&"
import style0 from "./NewMembers.vue?vue&type=style&index=0&id=927105de&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927105de')) {
      api.createRecord('927105de', component.options)
    } else {
      api.reload('927105de', component.options)
    }
    module.hot.accept("./NewMembers.vue?vue&type=template&id=927105de&", function () {
      api.rerender('927105de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/NewMembers.vue"
export default component.exports